import React from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Divider,
  Typography,
  Paper,
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LoginIcon from '@mui/icons-material/Login';
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Link } from "react-router-dom";
import { Company } from "../../../interfaces/entities/company";
import {
  ProfileSection,
  AvatarWrapper,
  CompanyNameRow,
  CompanyName,
  IconWrapper,
  InfoLabel
} from "./companyView.styles";
import { Collection } from "../../../enums/collections.enum";
import { useAuthenticatedUser } from "../../../hooks/useAuthenticatedUser";

interface CompanyViewProps {
  company: Company;
  onDelete?: () => void;
  onLoginAsOwner?: () => void;
}

export const CompanyView: React.FC<CompanyViewProps> = ({
  company,
  onDelete,
  onLoginAsOwner
}) => {

  const { currentUserIsOwnerOf, isAdmin } = useAuthenticatedUser();

  return (
    <Box sx={{ margin: 2 }}>
      {
        (currentUserIsOwnerOf(company.id) || isAdmin) &&
        <Paper elevation={2} sx={{ padding: 3, mb: 3, bgcolor: "#f8f9fa70" }}>
          <ProfileSection>
            <AvatarWrapper
              src={company?.image || "/assets/default-user.jpg"}
              alt={company.name}
            />
            <CompanyNameRow>
              <CompanyName variant="h5">
                {company.name}
              </CompanyName>
              <>
                {currentUserIsOwnerOf(company.id) && <Tooltip title="Edit Company">
                  <IconButton
                    component={Link}
                    to={`/${Collection.Companies}/${company.id}/edit`}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>}

                {isAdmin && <Tooltip title="Login as Company Owner">
                  <IconButton
                    onClick={onLoginAsOwner}
                    color="primary"
                  >
                    <LoginIcon />
                  </IconButton>
                </Tooltip>}

                {isAdmin && <Tooltip title="Delete Company">
                  <IconButton
                    onClick={onDelete}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>}
              </>
            </CompanyNameRow>
          </ProfileSection>

          <Divider />

          <Box sx={{ mt: 1 }}>
            <IconWrapper>
              <LocationOnIcon color="action" />
              <Typography>
                <InfoLabel>Address:</InfoLabel> {company?.address || "Not available"}
              </Typography>
            </IconWrapper>

            <IconWrapper>
              <PhoneIcon color="action" />
              <Typography>
                <InfoLabel>Contact:</InfoLabel> {company?.contact || "Not available"}
              </Typography>
            </IconWrapper>

            <IconWrapper>
              <EmailIcon color="action" />
              <Typography>
                <InfoLabel>Email:</InfoLabel> {company?.email || "Not available"}
              </Typography>
            </IconWrapper>

            <IconWrapper>
              {company?.config?.phoneMandatoryForReview ? (
                <CheckCircleIcon color="success" />
              ) : (
                <CancelIcon color="error" />
              )}
              <Typography>
                <InfoLabel>Phone Mandatory for Review:</InfoLabel>{" "}
                {company?.config?.phoneMandatoryForReview ? "Yes" : "No"}
              </Typography>
            </IconWrapper>
          </Box>
        </Paper>}
    </Box>
  );
};
